exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-5831fde5] {\n  height: 120px;\n  width: 120px;\n}\n@media screen and (max-width: 895px) {\n.info-title[data-v-5831fde5] {\n    font-size: 20px;\n}\n.info-sec[data-v-5831fde5] {\n    font-size: 20px;\n}\n}\n", ""]);

// exports
